import { API_URL } from '../configAndUrls.js'
import { apiRequest } from '../http.js'

export const tenantsApi = {
getBySlug: async (slug) => {
      const response = await fetch(`${API_URL}/tenants/by-slug/${encodeURIComponent(slug)}`)
      if (!response.ok) throw new Error('Tenant not found')
      return response.json()
    },
    
    getAll: async ({ includeArchived = false, ...options } = {}) => {
      const q = includeArchived ? '?includeArchived=true' : ''
      const data = await apiRequest(`/tenants${q}`, options)
      return data.tenants || []
    },
    
    getById: async (id, options = {}) => {
      return apiRequest(`/tenants/${id}`, options)
    },
    
    create: async (body) => {
      return apiRequest('/tenants', { method: 'POST', body: JSON.stringify(body) })
    },
    
    update: async (id, body, options = {}) => {
      const data = await apiRequest(`/tenants/${id}`, {
        ...options,
        method: 'PUT',
        body: JSON.stringify(body),
      })
      return data.tenant
    },
    
    getDeletionImpact: async (id, options = {}) => {
      return apiRequest(`/tenants/${id}/deletion-impact`, options)
    },
    delete: async (id, { confirmSlug, impactChecksum, ...options } = {}) => {
      await apiRequest(`/tenants/${id}`, {
        ...options,
        method: 'DELETE',
        body: JSON.stringify({ confirmSlug, impactChecksum }),
      })
    },
    archive: async (id, options = {}) => {
      const data = await apiRequest(`/tenants/${id}/archive`, { ...options, method: 'POST' })
      return data.tenant
    },
    restore: async (id, options = {}) => {
      const data = await apiRequest(`/tenants/${id}/restore`, { ...options, method: 'POST' })
      return data.tenant
    },
    
    addAdmins: async (tenantId, emails) => {
      const list = Array.isArray(emails) ? emails : [emails]
      return apiRequest(`/tenants/${tenantId}/admins`, {
        method: 'POST',
        body: JSON.stringify(list.length === 1 ? { email: list[0] } : { emails: list }),
      })
    },
    
    removeAdmin: async (tenantId, email, options = {}) => {
      await apiRequest(`/tenants/${tenantId}/admins`, {
        ...options,
        method: 'DELETE',
        body: JSON.stringify({ email }),
      })
    },
    
    resendAdminInvite: async (tenantId, email, options = {}) => {
      return apiRequest(`/tenants/${tenantId}/admins/resend-invite`, {
        ...options,
        method: 'POST',
        body: JSON.stringify({ email }),
      })
    },
    
    getLogoUploadUrl: async (id, { filename, contentType }) => {
      const data = await apiRequest(`/tenants/${id}/logo-upload-url`, {
        method: 'POST',
        body: JSON.stringify({ filename, contentType }),
      })
      return { uploadUrl: data.uploadUrl, publicUrl: data.publicUrl }
    },

    grantFreeBillingAccess: async (id, { reason, expiresAt } = {}, options = {}) => {
      return apiRequest(`/tenants/${id}/billing/free-grant`, {
        ...options,
        method: 'POST',
        body: JSON.stringify({ reason, expires_at: expiresAt || null }),
      })
    },

    revokeFreeBillingAccess: async (id, options = {}) => {
      return apiRequest(`/tenants/${id}/billing/free-grant`, {
        ...options,
        method: 'DELETE',
      })
    },

    cutoverFreeBillingGrants: async ({ reason } = {}, options = {}) => {
      return apiRequest('/tenants/billing/cutover-free-grants', {
        ...options,
        method: 'POST',
        body: JSON.stringify({ reason: reason || 'Beta cutover free access' }),
      })
    },
}
